import ThisModule from "./EditableTable";

export default ThisModule;
